<template>
    <div>
        <div id="worksends-page-header" class="tw-grid tw-mt-2 tw-grid-cols-2">
            <div>
                <div class="breadcrumbs" id="breadcrumbs">
                    <span class="breadcrumb-link">Marketplace</span>  &gt;
                    <router-link class="breadcrumb-link" to="/marketplace/orders">Order History</router-link>
                </div>
                <h3 style="float: left;">Marketplace <span>Order History</span></h3>
            </div>
            
            <div class="ws-filters tw-flex tw-justify-end">
                <div class="ws-filter ws-filter-select">
                    <label>Order Made By</label>
                    <select v-if="user.permissions && user.permissions.includes('view-others-orders')" v-model="pageParams.filters.registered_by.val" name="marketplace-product-type" @change="setFilter">
                        <option value="null">All Team Members</option>
                        <option v-for="person in filteredManagers" :value="person.user_id">{{ person.name }}</option>
                    </select>
                    <select v-else disabled>
                        <option>{{ user.name }} (You)</option>
                    </select>
                </div>
    
                <div class="ws-filter">
                    <label>Link Invite</label>
                    <div class="ws-filter-switch" :data-state="filterToYesNo('visited_at')" @click="toggleFilter('visited_at')"><div class="ws-filter-switch-knob"></div></div>
                </div>
    
                <div class="ws-filter">
                    <label>Confirmed</label>
                    <div class="ws-filter-switch" :data-state="filterToYesNo('confirmed_at')" @click="toggleFilter('confirmed_at')"><div class="ws-filter-switch-knob"></div></div>
                </div>
    
                <div class="ws-filter">
                    <label>Sent</label>
                    <div class="ws-filter-switch" :data-state="filterToYesNo('sent_at')" @click="toggleFilter('sent_at')"><div class="ws-filter-switch-knob"></div></div>
                </div>
    
                <div class="ws-filter">
                    <label>Rejected</label>
                    <div class="ws-filter-switch" :data-state="filterToYesNo('rejected_at')" @click="toggleFilter('rejected_at')"><div class="ws-filter-switch-knob"></div></div>
                </div>
            </div>
        </div>

		<table id="list-of-recipients"  class="worksends-table cb-table status-">
			<thead>
			<tr>
				<th class="field-r_name">Recipient</th>
				<th class="field-method">Added as</th>
				<th class="field-g_registered">Gift</th>
				<th class="field-g_sent">Fulfillment</th>
                <th class="field-price">Gift Price</th>
				<th class="field-costs">Shipping & Admin</th>
                <!--<th class="field-by">Order Made by</th>-->
				<th class="field-actions">Actions</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="r in registrations.data" :key="r.id">
				<td class="field-r_name" data-label="Recipient"><div class="value"><b>{{ r.first_name }} {{ r.last_name }}</b></div><div class="value">{{ r.email }}</div></td>
				<td class="field-added_as" data-label="Added as" style="width: 130px;">
					<div class="value">
						<div v-if="r.invited_at" class="yesno yes">LINK INVITE<div class="yesno-by" v-if="r.invited_by_name">{{ r.invited_by_name }}</div></div>
						<div v-else-if="r.registered_by" class="yesno manual">DIRECT SEND<div class="yesno-by" v-if="r.registered_by_name">{{ r.registered_by_name }}</div></div>
						<div v-else class="yesno no">UNKNOWN</div>
					</div>
				</td>
				<td class="field-g_registered" data-label="Gift">
					<div class="value">
						<div v-if="(r.invited_at || r.registered_at && Number(r.product_id)!=0) || r.type=='voucher'" class="yesno yes">
							{{ r.product_name }}
							<span v-if="r.quantity > 1"> ({{ r.quantity }})</span>
							<div class="yesno-date">{{ r.registered_at }}</div>
						</div>
						<div v-else-if="r.registered_at" class="yesno no">OPTED-OUT
							<div class="yesno-date">{{ r.registered_at }}</div>
						</div>
						<div v-else class="yesno no">No</div>
					</div>
				</td>
				<td class="field-g_sent" data-label="Fulfillment">
					<div class="value">
                        <div v-if="r.rejected_at" class="yesno no">Rejected</div>
                        <div v-else-if="!r.confirmed_at" class="yesno no">Unclaimed</div>
						<div v-else-if="!r.sent_at && !r.processed_at" class="yesno yes">Processing<div class="yesno-date">{{ r.confirmed_at }}</div></div>
						<div v-else-if="!r.sent_at && r.processed_at" class="yesno yes">Processing<div class="yesno-date">{{ r.processed_at }}</div></div>
						<div v-else-if="r.sent_at" class="yesno yes">Sent <a class="ws-tracking-link" v-if="r.tracking_url" :href="r.tracking_url" target="_blank" >Tracking Link →</a><div class="yesno-date">{{ r.sent_at }}</div></div>
						<div v-else class="yesno no">No</div>
					</div>
				</td>
                <td class="field-price" data-label="Gift Price">
                    <div class="value" v-if="((r.invited_at || r.registered_at) && Number(r.product_id)!=0)"><b>{{ Number(r.gift_iv_cost) | toCurrency }}</b></div>
                    <div class="value" v-else-if="r.voucher_value"><b>{{ Number(r.voucher_value) | toCurrency }}</b></div>
                </td>
				<td class="field-costs" data-label="Shipping & Admin"><div class="value" v-if="(r.invited_at || r.registered_at && Number(r.product_id)!=0) || r.type=='voucher'">{{ (Number(r.pp_iv_cost) + Number(r.shipping_iv_cost)) | toCurrency }}</div></td>
				<!-- <td class="field-by">{{ r.registered_by_name }}</td> -->
                <td class="field-actions" data-label="Actions" style="width: 180px;" >
					<div class="value">
						<div v-if="r.invited_at && !r.confirmed_at && !r.rejected_at" @click="openGiftRegistrationLinkModal(r)" class="ws-button small">Gift Claim Link</div>
						<div v-else class="ws-button ws-button-secondary small" @click="openEditRegistration(r)">View Details</div>
					</div>
				</td>
			</tr>
			</tbody>
		</table>
		<ws-table-meta :meta="registrations.meta" :sum="'There are % marketplace orders in total '+registrationSumExtra+'.'"></ws-table-meta>

        <gift-registration-modal v-if="modals.giftRegistrationModalEdit" :fetch-item="false" :registration-id="editRegId" :product-id="editRegProdId"  @created="onEditRegistration" :type="'edit'" platform="marketplace"></gift-registration-modal>
        <gift-invite-modal v-if="modals.giftInviteModal" :product-id="productId" :registration-link-details="registrationLinkDetails" platform="marketplace" @generated="onLinkGenerate"></gift-invite-modal>

    </div>
</template>

<script>
import GiftRegistrationModal from '@/components/modals/GiftRegistrationModal';
import GiftInviteModal from "@/components/modals/GiftInviteModal";

export default {
    name: "MarketplaceOrdersIndex",
    components: {GiftRegistrationModal, GiftInviteModal},
    data() {
		return {
			editRegId: null, editRegProdId: null,
			registrationLinkDetails: {},
			todayDate: new Date(),
			pageParams: {
				pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 10},
				search: {val: ""},
				filters: {
					invited_at: { val: null, type: 'single' },
					registered_by: { val: null, type: 'single' },
					visited_at: { val: null, type: 'single' },
					confirmed_at: { val: null, type: 'single' },
					sent_at: { val: null, type: 'single' },
                    rejected_at: { val: null, type: 'single' },
				}
			}
		}
	},
    methods: {
        async getPage(params) {
			return this.getPageHandler({
				waitName: 'marketplace_orders.index',
				action: 'fetchGiftBoxRegistrations', // vuex action
				routeParams: {platform: 'marketplace'},
				pageParams: this.pageParams,
				isInit: params ? params.init : false, // parse from url query params
				pushRoute: false, // push pagination params and search q to route
				resetPagination: params ? params.resetPagination : false // new search input || filters -> need to reset page & sorting
			});
		},
        async fetchData() {
            if (this.user.role=='associate') {
                this.pageParams.filters.registered_by.val = this.user.user_id;
            } else {
                this.pageParams.filters.registered_by.val = null;
            }
            this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
            return this.getPage();
		},
		filterToYesNo(filter) {
			return this.pageParams.filters[filter].val === true ? 'yes' : (this.pageParams.filters[filter].val === false ? 'no' : 'all');
		},
		toggleFilter(filter, nullable = true) {
			if (this.pageParams.filters[filter].val === null) this.pageParams.filters[filter].val = true;
			else if (this.pageParams.filters[filter].val === true) this.pageParams.filters[filter].val = false;
			else if (this.pageParams.filters[filter].val === false) this.pageParams.filters[filter].val = nullable ? null : true;
			else { return; }

			this.getPage({resetPagination: true});
		},
        setFilter() {
            this.getPage({resetPagination: true});
        },
		sortBy(field) {
			if (this.pageParams.pageOptions.sortBy[0] === field) {
				if (this.pageParams.pageOptions.sortDesc[0] === false) {
					this.pageParams.pageOptions.sortBy = [];
					this.pageParams.pageOptions.sortDesc = [];
				} else {
					this.pageParams.pageOptions.sortDesc = [false];
				}
			} else {
				this.pageParams.pageOptions.sortBy = [field];
				this.pageParams.pageOptions.sortDesc = [true];
			}
		},
		sortClass(field, sortBy, sortDesc) { // pageOptions param just to be reactive
			if (this.pageParams.pageOptions.sortBy && this.pageParams.pageOptions.sortBy[0] === field) {
				return {'sort': true, 'sort-up': !this.pageParams.pageOptions.sortDesc[0], 'sort-down': this.pageParams.pageOptions.sortDesc[0]};
			}
			return {};
		},
		onEditRegistration(registration) {
			this.getPage({resetPagination: true});
			this.modals.giftRegistrationModalEdit = false;
		},
		openEditRegistration(reg) {
			this.editRegId = parseInt(reg.id);
            this.editRegProdId = parseInt(reg.product_id);
			this.modals.giftRegistrationModalEdit = true;
		},
        openGiftRegistrationLinkModal(r) {
			if (r) {
				this.editRegId = parseInt(r.id);
				this.viewRegistrationLink = this.$store.state.gbPageUrlBase+'?invite='+r.secret;
				this.registrationLinkDetails = {
					'registration_id': r.id,
					'invite_link': this.$store.state.gbPageUrlBase+'?invite='+r.secret,
					'password_type': r.password_type,
					'password_value': (r.password_type=='email')?r.email:(r.first_name+' '+r.last_name),
				};
			} else {
				this.registrationLinkDetails = {};
			}
			this.modals.giftInviteModal = true;
		},
	},
	mounted() {
        this.fetchData();
	},
	computed: {
		team() {
			return this.$store.state.team.detail;
		},
        user() {
            return this.$store.state.currentUser;
        },
		registrations() {
			return this.$store.state.giftBoxCampaign.registrations;
		},
		privacyLevels() {
			return this.$store.state.privacyLevels;
		},
		modals() {
			return this.$store.state.modals;
		},
		restApiNonce() {
			return window.restApiNonce;
		},
        registrationSumExtra() {
            if (this.user.permissions && this.user.permissions.includes('view-others-orders')) return '<i>made by your team</i>';
            else return '<i>made by you</i>';
        },
        filteredManagers() {
            return this.team.managers.filter(person =>
                ['associate', 'manager'].includes(person.role)
            );
        }
	},
	watch: {
		'pageParams.pageOptions': {
			handler (newVal, oldVal) {
				if (oldVal !== newVal)
					this.getPage();
			},
			deep: true,
		}
	}
}
</script>

<style>

</style>
